import BaseAlertTable from "./base-alert-table.vue";

export default BaseAlertTable;



// WEBPACK FOOTER //
// ./src/components/_dashboard/alerts/table/base-alert-table/index.js